const CashOnDelivery = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]" />
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Retail COD
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              Retail-COD makes shipping simple and convenient for small
              businesses, home-based sellers, retailers and startups, with no
              complicated account requirements. This Independence season,
              there’s even more reason to ship with TCS.
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              To celebrate Pakistan’s 79th Birthday, customers can now pay only
              79% of the applicable Retail-COD tariff on their shipments and
              automatically get a chance to enter the Jashn-e-Pakistan Lucky
              Draw. Eligible customers can win exciting prizes.
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              Ship more and make every delivery a chance to win with TCS Retail
              COD.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center lg:mt-[0rem] mt-[1rem]">
            <img
              src="/ecom-solution/R-COD.jpeg"
              alt=""
              className="rounded-md max-w-[100%]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default CashOnDelivery;
